import { render, staticRenderFns } from "./IconStatsAveragePlay.vue?vue&type=template&id=88318dd0&"
import script from "./IconStatsAveragePlay.vue?vue&type=script&lang=js&"
export * from "./IconStatsAveragePlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88318dd0')) {
      api.createRecord('88318dd0', component.options)
    } else {
      api.reload('88318dd0', component.options)
    }
    module.hot.accept("./IconStatsAveragePlay.vue?vue&type=template&id=88318dd0&", function () {
      api.rerender('88318dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconStatsAveragePlay.vue"
export default component.exports